import GanymedePageContainer from "../../components/ganymede/PageContainer";
import GanymedeDocumentHeader from "../../components/ganymede/DocumentHeader";
import GanymedePageFooter from "../../components/ganymede/PageFooter";
import "./contracts.css";
import { useNavigate } from "react-router-dom";

function ServiceAgreement() {
  const navigate = useNavigate();

  return (
    <>
      <GanymedePageContainer className={"service-agreement-container"}>
        <div className={"InvoiceHeader"}>
          <GanymedeDocumentHeader
            title={"MEMBERSHIP AGREEMENT — SNOUT, INC."}
          />
        </div>
        <div className={"service-agreement-scroll-container"}>

          <p className="intro-text">
            This Snout Plan Membership Agreement (
            <strong><em>"Membership Agreement"</em></strong>
            ) constitutes a legally binding agreement between you (
            <strong><em>"you"</em></strong> or <strong><em>"Member"</em></strong>
            ) and Snout, Inc. (<strong><em>"Snout"</em></strong>) governing your
            enrollment in a Snout Plan, as described in more detail in the
            Platform Terms (the <strong><em>"Terms"</em></strong>), and
            collectively with this Membership Agreement, the{" "}
            <strong><em>"Agreement."</em></strong> Your participation in the
            Snout Plan and use of Snout's Services (as defined in the Terms) is
            subject at all times to all terms of the Agreement. The{" "}
            <a href="https://www.snout.com/platform-terms" target="_blank" rel="noreferrer">Platform Terms</a> and{" "}
            <a href="https://www.snout.com/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a> are incorporated herein by
            reference. All terms not defined herein shall have the meaning set
            forth in the Terms.
          </p>

          <p>
            YOU ACKNOWLEDGE AND AGREE THAT, BY CLICKING ON THE "I AGREE" OR
            SIMILAR BUTTON, REGISTERING FOR AN ACCOUNT WITH SNOUT, OR ACCESSING
            OR USING THE SNOUT PLAN, YOU ARE REPRESENTING AND WARRANTING THAT
            (I) YOU ARE AT LEAST 18 YEARS OLD AND (II) YOU HAVE READ, UNDERSTAND
            AND AGREE TO BE BOUND BY THIS AGREEMENT. IF YOU DO NOT AGREE TO THIS
            AGREEMENT, THEN YOU HAVE NO RIGHT TO ACCESS OR USE THE SNOUT PLAN.
            This Agreement is effective as of the date you first click "I agree"
            (or similar button or checkbox) or use or access the Snout Plan,
            whichever is earlier.
          </p>

          <ol>
            <li>
              <h3>SNOUT PLANS</h3>
              <ul>

                <li>
                  <strong>Coverage of Plans.</strong> By enrolling in a Snout
                  Plan, Member agrees to pay the monthly membership fee listed on
                  the receipt provided at enrollment (the{" "}
                  <strong><em>"Receipt"</em></strong>). In exchange, subject to
                  the terms of this Agreement, Snout will pay the participating
                  veterinary practice associated with the Plan (the{" "}
                  <strong><em>"Practice"</em></strong>) directly only for those
                  specific services, products, and quantities expressly listed in
                  the Receipt (the <strong><em>"Plan Items"</em></strong>). Snout
                  does not provide veterinary care; all medical services are
                  provided solely by the Practice. Plan benefits are strictly
                  limited to: (1) the Plan Items specifically identified in the
                  Receipt, (2) services performed by the enrolled Practice (or
                  approved shared cross-usage locations, if applicable), and (3)
                  the single pet identified at enrollment (the{" "}
                  <strong><em>"Eligible Pet"</em></strong>). At this time, Snout
                  offers plans exclusively for dogs and cats, and has no age,
                  breed, or pre-existing condition restrictions. Plans for other
                  species are not currently available. Any service, product, or
                  treatment not expressly listed in the Receipt is not covered
                  under the Plan. Snout Plans are non-transferable and may not be
                  assigned to another person or used for any pet other than the
                  Eligible Pet. Member is responsible for promptly notifying Snout
                  of any changes to the Eligible Pet, ownership, contact
                  information, payment method, or enrolled Practice location.
                </li>

                <li>
                  <strong>Disclaimer on Veterinary Services.</strong> All
                  veterinary services under any Snout Plan are provided solely and
                  independently by the Practice (
                  <strong><em>"Veterinary Services"</em></strong>). Snout does not
                  itself provide any veterinary or medical services and does not
                  control, oversee, or guarantee the professional judgment,
                  quality, availability, or outcomes of the services rendered by a
                  Practice. Any treatment decisions, diagnoses, or care
                  recommendations are the sole responsibility of the Practice and
                  its licensed veterinary professionals. Accordingly, Snout shall
                  have no responsibility or liability to you or your pet for any
                  acts, errors, omissions, or negligence of a Practice or its
                  personnel in connection with such services.
                </li>

                <li>
                  <strong>Member Eligibility.</strong> Members must be eighteen
                  (18) years of age or older and must provide a valid email
                  address. If Snout discovers that a Member is under eighteen
                  (18), Snout reserves the right to immediately suspend the Snout
                  Plan until resolved.
                </li>

                <li>
                  <strong>Plan Terms and Payment Obligations.</strong>
                  <ul>
                    <li>
                      <strong>Trial Period.</strong> Within fourteen (14) calendar
                      days of the date of the Receipt and provided that you have
                      not used any Veterinary Services at the Practice (the{" "}
                      <strong><em>"Trial Period"</em></strong>), you may cancel
                      the Snout Plan by providing written notice to Snout and
                      receive a full refund of the prepaid Monthly Membership Fee.
                      No refunds will be given after the expiration of the Trial
                      Period.
                    </li>
                    <li>
                      <strong>Plan Term.</strong> Unless otherwise set forth in
                      the Receipt, the initial term for each Snout Plan is for 12
                      months (the{" "}
                      <strong><em>"Initial Plan Term"</em></strong>), and shall be
                      automatically renewed for additional periods of the same
                      duration as the Initial Plan Term (each, a{" "}
                      <strong><em>"Renewal Plan Term"</em></strong> and
                      collectively with the Initial Plan Term, the{" "}
                      <strong><em>"Plan Term"</em></strong>) unless you provide
                      written notice of non-renewal at least 10 days prior to the
                      Initial Plan Term or then-current Renewal Plan Term (the{" "}
                      <strong><em>"Request Deadline"</em></strong>). For the
                      avoidance of doubt, puppy and kitten plans shall
                      automatically renew for adult plans at the applicable age.
                    </li>
                    <li>
                      <strong>Fees.</strong> During the Plan Term, on a monthly
                      basis, Members shall owe Snout (i) in advance, a monthly
                      membership fee, as set forth on the Receipt (the{" "}
                      <strong><em>"Monthly Membership Fee"</em></strong>), (ii) in
                      arrears, all fees and other charges applicable to any
                      Non-Plan Items and Add-Ons incurred in the preceding month
                      (the <strong><em>"Additional Service Fees"</em></strong> and
                      together with the Monthly Membership Fee, the{" "}
                      <strong><em>"Fees"</em></strong>). All Fees stated are
                      exclusive of all taxes, duties, levies, imposts, fines, or
                      similar governmental assessments (collectively,{" "}
                      <strong><em>"Taxes"</em></strong>). Members will be
                      responsible for and bear all Taxes associated with the
                      purchase of, payment for, access to or use of the Snout
                      Plan.
                    </li>
                    <li>
                      <strong>Invoicing; Non-Plan Items and Overages.</strong>{" "}
                      Members are fully and solely responsible for payment of (i)
                      any services, products, treatments, diagnostics, medications,
                      or other items not expressly included in, covered by, or
                      within the stated quantities of the Snout Plan (
                      <strong><em>"Non-Plan Items"</em></strong>), and (ii) any
                      amounts that exceed applicable coverage limits, caps, or
                      maximum dollar amounts for covered Plan Items (
                      <strong><em>"Overages"</em></strong>). Any item or service
                      not specifically listed in the Receipt as included in the
                      Plan, or any portion of a covered item that exceeds the
                      stated quantity or dollar cap, is the Member's financial
                      responsibility. By enrolling in the Plan, Member expressly
                      authorizes Snout to charge the payment method on file for
                      the full amount of all Non-Plan Items and Overages
                      immediately upon invoicing. In practice, when a Member
                      visits the Practice, the Practice submits the invoice to
                      Snout. Snout does not accept claims from veterinary practices
                      outside of its network or invoices submitted directly by
                      Members. Snout's rejection of any invoice due to late
                      submission or an inactive Snout Plan does not relieve Member
                      of its obligation to pay the Practice directly for services
                      rendered. Snout processes the invoice, determines which items
                      are covered under the Plan, and charges the Member's payment
                      method on file for any Non-Plan Items or Overages. Snout
                      reserves the right to decline, delay, reverse, adjust, or
                      withhold payment of any invoice that Snout reasonably
                      believes contains errors, fraud, abuse, duplicate charges,
                      ineligible charges, or charges inconsistent with the
                      applicable Snout Plan. If any charge is declined, returned,
                      or otherwise fails for any reason, Snout is authorized to
                      reattempt such charge and to continue collection efforts
                      until the outstanding balance is paid in full. If Member
                      initiates a chargeback, payment dispute, or reversal with
                      respect to any amount owed under this Agreement, Snout
                      reserves the right to immediately suspend or terminate the
                      Snout Plan and pursue collection of all outstanding amounts,
                      including any associated fees, costs, or expenses incurred
                      by Snout.
                    </li>
                    <li>
                      <strong>Late Fees.</strong> If Snout does not receive
                      payment from you by the required due date, you agree to pay
                      all outstanding amounts immediately upon demand. Any payments
                      received after the due date will be considered late and will
                      incur a late fee (<strong><em>"Late Fee"</em></strong>) of
                      $15.00 USD. If any payment remains outstanding for thirty
                      (30) calendar days or more, Snout may terminate this
                      Agreement immediately.
                    </li>
                    <li>
                      <strong>Reimbursement; Collection.</strong> Member will
                      reimburse Snout any costs or expenses (including, but not
                      limited to, reasonable attorneys' fees and collection agency
                      costs) incurred by Snout to collect any amount that is not
                      paid when due. Snout may accept payment in any amount without
                      prejudice to its right to recover the balance of the amount
                      due or to pursue any other right or remedy. Amounts due to
                      Snout may not be withheld or offset by you for any reason
                      against amounts due or asserted to be due from Snout.
                    </li>
                    <li>
                      <strong>Suspension for Non-Payment.</strong> A Member is not
                      in good standing if the Member has failed to make any payment
                      when due to Snout, including Monthly Membership Fees,
                      Additional Service Fees, Non-Plan Items, Overages,
                      cancellation fees, Late Fees, or any other amounts owed to
                      Snout, whether related to the applicable Eligible Pet or any
                      other pet owned by the Member. If a Member is not in good
                      standing at the time services are requested or rendered, the
                      Snout Plan will be automatically suspended until the account
                      is brought fully current. During suspension, the Member is
                      not entitled to any Plan benefits and is fully responsible
                      for paying the Practice directly for all services at the
                      Practice's standard rates. Fees will continue to accrue
                      during any period of suspension, and the Plan Term will not
                      be extended. Snout shall have no obligation to process, pay,
                      or reimburse any invoice or provide any Plan benefits while a
                      Member account is delinquent, suspended, terminated, or
                      otherwise not in good standing.
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>Termination of Snout Plans.</strong>
                  <ul>
                    <li>
                      <strong>Termination.</strong> You may terminate your Snout
                      Plan prior to the end of an applicable Plan Term upon at
                      least thirty (30) days' prior written notice to Snout only
                      in the event of: (i) your relocation to a new place of
                      residence that is at least twenty (20) miles from the office
                      of the Practice; (ii) the Practice permanently ceases
                      operations; (iii) the Practice relocates at least twenty
                      (20) miles from its previous location; or (iv) the death or
                      re-homing of an Eligible Pet. In all cases, termination
                      under this Section is conditioned upon your providing written
                      documentation reasonably acceptable to Snout, in Snout's
                      sole discretion, substantiating the applicable circumstance.
                      Snout reserves the right to deny any termination request
                      that is not supported by sufficient documentation. Snout may
                      terminate a Snout Plan at any time and for any reason upon
                      notice to you, including immediately for non-payment,
                      suspected fraud, abuse, misuse of the Plan, chargebacks, or
                      violation of the Agreement.
                    </li>
                    <li>
                      <strong>Fees Upon Termination.</strong> Without limiting
                      Snout's other rights and remedies, upon termination of a
                      Snout Plan: (i) Snout will not pay the Practice for any
                      Veterinary Services provided to you after termination; you
                      will be solely responsible for paying all fees or charges
                      owed to the Practice for those services, (ii) if, as of the
                      termination date, the total Monthly Membership Fees you have
                      paid to Snout during the Plan Term are less than the value
                      of the Veterinary Services you have already received (as
                      determined under the Practice Agreement between Snout and
                      the applicable Practice), you must immediately pay the
                      difference (the{" "}
                      <strong><em>"Snout Balance"</em></strong>) to Snout, and
                      (iii) if the total Monthly Membership Fees you have paid
                      during the Plan Term are greater than the value of the
                      Veterinary Services provided to you (as listed on your
                      Receipt), no refund or credit will be issued.
                    </li>
                  </ul>
                </li>

                <li>
                  <strong>Disclaimers.</strong> Snout is not offering an insurance
                  policy as part of the Snout Plan. The Snout Plan is offered
                  separately and distinctly from any insurance. SNOUT MAKES NO
                  WARRANTIES REGARDING THE VETERINARY SERVICES PROVIDED BY THE
                  PRACTICE; NOR DOES IT MAKE ANY WARRANTY AS TO THE RESULTS THAT
                  MAY BE OBTAINED FROM SUCH VETERINARY SERVICES. EXCEPT AS
                  EXPRESSLY SET FORTH IN THIS SECTION, SNOUT PLANS ARE PROVIDED
                  "AS IS" AND SNOUT DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED,
                  INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
                  MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE AND
                  NON-INFRINGEMENT.
                  <p>
                    TELEMEDICINE SERVICES ACCESSED THROUGH THE SERVICES, INCLUDING
                    VIDEO, AUDIO, MESSAGING, AND ASYNCHRONOUS CONSULTS, ARE
                    PROVIDED SOLELY BY AN INDEPENDENT THIRD PARTY; SNOUT DOES NOT
                    PROVIDE VETERINARY CARE, MEDICAL ADVICE, DIAGNOSIS, OR
                    TREATMENT, AND DOES NOT SUPERVISE OR CONTROL CLINICAL
                    JUDGMENT; TELEMEDICINE IS NOT A SUBSTITUTE FOR AN IN-PERSON
                    EXAMINATION OR EMERGENCY CARE AND MAY BE LIMITED BY
                    TECHNOLOGY, CONNECTIVITY, AND THE ABSENCE OF HANDS-ON
                    EXAMINATION. AVAILABILITY OF TELEMEDICINE, AND ANY DIAGNOSES,
                    TREATMENT, OR PRESCRIPTIONS PROVIDED THEREUNDER, ARE SUBJECT
                    TO APPLICABLE LAW AND THE PRACTICE'S CLINICAL JUDGMENT;
                    MEMBERS MUST ACCURATELY DISCLOSE THEIR LOCATION AND PET
                    INFORMATION. YOUR RELIANCE ON ANY VETERINARY ADVICE PROVIDED
                    VIA TELEMEDICINE IS AT YOUR SOLE RISK; TO THE MAXIMUM EXTENT
                    PERMITTED BY LAW, SNOUT DISCLAIMS ALL LIABILITY FOR LOSSES,
                    DAMAGES, OR CLAIMS ARISING OUT OF OR RELATING TO TELEMEDICINE
                    SERVICES ACCESSED THROUGH THE PLATFORM. IF YOU BELIEVE YOUR
                    PET IS EXPERIENCING AN EMERGENCY, SEEK IMMEDIATE IN-PERSON
                    CARE BY CONTACTING YOUR LOCAL EMERGENCY VETERINARY CLINIC.
                  </p>
                </li>

                <li>
                  <strong>Payment Terms.</strong>
                  <ul>
                    <li>
                      <strong>Billing.</strong> Snout uses a third-party payment
                      processor (the{" "}
                      <strong><em>"Payment Processor"</em></strong>) to bill
                      Members through a payment account linked to the Member's
                      account on the Snout Plan (each, a{" "}
                      <strong><em>"Billing Account"</em></strong>) for use of the
                      Snout Plan. The processing of payments will be subject to
                      the terms, conditions and privacy policies of the Payment
                      Processor in addition to these Terms. Currently, Snout uses
                      Stripe, Inc. as its Payment Processor. You can access
                      Stripe's Terms of Service at{" "}
                      <a
                        href="https://stripe.com/us/checkout/legal"
                        target="_blank"
                        rel="noreferrer"
                      >
                        https://stripe.com/us/checkout/legal
                      </a>{" "}
                      and their Privacy Policy at{" "}
                      <a
                        href="https://stripe.com/us/privacy"
                        target="_blank"
                        rel="noreferrer"
                      >
                        https://stripe.com/us/privacy
                      </a>
                      . Snout is not responsible for any error by, or other acts
                      or omissions of, the Payment Processor. By choosing to use
                      the Snout Plan, you agree to pay Snout, through the Payment
                      Processor, all charges at the prices then in effect for any
                      use of the Snout Plan in accordance with the applicable
                      payment terms, and you authorize Snout, through the Payment
                      Processor, to charge your chosen payment provider (your{" "}
                      <strong><em>"Payment Method"</em></strong>). You agree to
                      make payment using that selected Payment Method. Snout
                      reserves the right to correct any errors or mistakes that
                      the Payment Processor makes even if it has already requested
                      or received payment.
                    </li>
                    <li>
                      <strong>Payment Method.</strong> The terms of your payment
                      will be based on your Payment Method and may be determined
                      by agreements between you and the financial institution,
                      credit card issuer or other provider of your chosen Payment
                      Method. If Snout does not receive payment from you, you
                      agree to pay all amounts due on your Billing Account upon
                      demand.
                    </li>
                    <li>
                      <strong>Recurring Billing.</strong> You acknowledge that
                      Snout Plans may have an initial and recurring payment feature
                      and you accept responsibility for all recurring charges prior
                      to cancellation. SNOUT MAY SUBMIT PERIODIC CHARGES (E.G.,
                      MONTHLY) WITHOUT FURTHER AUTHORIZATION FROM YOU, UNTIL YOU
                      PROVIDE PRIOR NOTICE (RECEIPT OF WHICH IS CONFIRMED BY
                      SNOUT) THAT YOU HAVE TERMINATED THIS AUTHORIZATION OR WISH
                      TO CHANGE YOUR PAYMENT METHOD. SUCH NOTICE WILL NOT AFFECT
                      CHARGES SUBMITTED BEFORE SNOUT REASONABLY COULD ACT. TO
                      TERMINATE YOUR AUTHORIZATION OR CHANGE YOUR PAYMENT METHOD,
                      YOU MUST CONTACT SNOUT AT SUPPORT@SNOUT.COM OR THROUGH
                      OTHER METHODS MADE AVAILABLE BY SNOUT.
                    </li>
                    <li>
                      <strong>Current Information Required.</strong> YOU MUST
                      PROVIDE CURRENT, COMPLETE, AND ACCURATE INFORMATION FOR YOUR
                      BILLING ACCOUNT. YOU MUST PROMPTLY NOTIFY SNOUT OF ANY
                      CHANGES TO YOUR BILLING INFORMATION, INCLUDING CHANGES TO
                      YOUR BILLING ADDRESS, PAYMENT METHOD, OR PAYMENT METHOD
                      EXPIRATION DATE. YOU MUST ALSO PROMPTLY NOTIFY SNOUT IF
                      YOUR PAYMENT METHOD IS CANCELED OR IF YOU BECOME AWARE OF
                      ANY UNAUTHORIZED USE OF YOUR PAYMENT METHOD OR ACCOUNT
                      INFORMATION. IF YOU FAIL TO PROVIDE UPDATED INFORMATION, YOU
                      AGREE THAT SNOUT MAY CONTINUE CHARGING YOUR PAYMENT METHOD
                      FOR ANY AMOUNTS DUE.
                    </li>
                    <li>
                      <strong>Change in Amount Authorized.</strong> If the amount
                      to be charged to your Billing Account varies from the amount
                      you preauthorized (other than due to the imposition or change
                      in the amount of state sales taxes), you have the right to
                      receive, and Snout shall provide, notice of the amount to be
                      charged and the date of the charge before the scheduled date
                      of the transaction. Any agreement you have with your payment
                      provider will govern your use of your Payment Method. You
                      agree that Snout may accumulate charges incurred and submit
                      them as one or more aggregate charges during or at the end of
                      each billing cycle. Member must notify Snout in writing of
                      any disputed charge or invoice within thirty (30) days of
                      the applicable charge date, after which such charge or
                      invoice shall be deemed final. Failure to timely dispute a
                      charge constitutes a waiver of any claim relating to such
                      charge.
                    </li>
                    <li>
                      <strong>SMS Communications.</strong> If you provide your
                      mobile phone number and opt in to receive SMS/text messages
                      from Snout, we may send you transactional, service-related,
                      and, where permitted by applicable law, promotional messages,
                      including account updates, billing notifications, support
                      messages, and other information related to the Services and
                      Snout's offerings. Message frequency may vary. Message and
                      data rates may apply. You may opt out at any time by
                      replying STOP, and you may reply HELP for additional
                      information. SMS opt-in data and consent will not be shared
                      with third parties or affiliates for their marketing or
                      promotional purposes. We may share your mobile phone number
                      with service providers that assist us in delivering text
                      messages, but only as necessary to provide those services on
                      our behalf and subject to appropriate contractual
                      restrictions.
                    </li>
                  </ul>
                </li>

              </ul>
            </li>
          </ol>

        </div>

        {window.history.length > 1 && (
          <button
            className="back-btn my-6 sm:mb-0 w-full sm:w-auto"
            style={{ alignSelf: "center" }}
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        )}
      </GanymedePageContainer>
      <GanymedePageFooter />
    </>
  );
}

export default ServiceAgreement;
